import type { Note } from '@src/notes/domain/Note';
import { NotesClient } from '@src/notes/services/NotesClient';
import { useQuery } from '@tanstack/react-query';

export const useFindAllNotesForOrder = ({
  orderId,
  disabled,
}: {
  orderId: string;
  disabled?: boolean;
}) => {
  const {
    data: notes = [],
    isLoading,
    refetch,
  } = useQuery<Note[]>({
    queryKey: ['notes.findAllNotesForOrder', { orderId }],
    queryFn: () => NotesClient.findAllForOrder(orderId),
    enabled: !disabled,
  });

  return {
    notes,
    isLoading,
    refetch,
  };
};
